import { useTranslation } from 'react-i18next'
import { useFormContext } from '../../../../../../core/providers/FormProvider'
import QuestionSliderSettingRow from '../../components/inputs/QuestionSliderSettingRow'

const IntakeOverviewSettings: React.FC = () => {
  const { t } = useTranslation()
  const {
    question: [question],
    updateQuestion,
  } = useFormContext()

  const intakeOverview = question?.__settings?.intakeOverview || { showInSummary: false }

  if (!intakeOverview || !question) return null

  return (
    <>
      {Object.entries(intakeOverview)
        .filter(([, value]) => value !== undefined)
        .map(([property, value]) => (
          <QuestionSliderSettingRow
            key={`${question.__uuid}-label-settings-${property}`}
            title={t(`forms.settings.options.${property}`)}
            description={t(`forms.settings.options.${property}_description`)}
            onChange={() => updateQuestion({ __settings: { intakeOverview: { [property]: !value } } })}
            checked={value}
          />
        ))}
    </>
  )
}

export default IntakeOverviewSettings
